import React from "react";
import Context from "../../../Context";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import List from "../../Misc/List";
import Searchbox from "../../Misc/Searchbox";
import MaintListItem from "./MaintListItem";

export default class MaintList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      catalogItem: false,
      textSearchValue: "",
      pending: false,
      searchPending: false,
      search: [],
      filters: {
        show: false,
        active: [],
        default: [],
        all: [],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: {
        all: [],
        active: [],
      },
    };
  }

  componentDidMount() {
    this.setDefaultFilters();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.structureId !== this.props.structureId) {
      this.setDefaultFilters();
    }
  }

  setDefaultFilters = async () => {
    let structureId = false;
    if (this.props.structureId && this.props.structureId !== "any") {
      structureId = this.props.structureId;
    }

    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];

      if (structureId) {
        filters.default.push({
          field: "structure",
          compare: "EQL",
          value: structureId,
        });
      }

      return filters;
    });
  };

  handleSearch = (text) => {
    let search = text
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${text}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  render() {
    const { structureId } = this.props;
    if (!structureId) {
      return <DefaultNotFound message="Выберите вид ТО" />;
    }

    return (
      <>
        <div className="mb-2">
          <Searchbox onSearch={this.handleSearch} />
        </div>
        {this.props.structureId && (
          <List
            listKey="maintList"
            key={this.props.customListKey}
            fulltext={JSON.stringify(this.state.search)}
            search={JSON.stringify(
              this.state.filters.active.concat(this.state.filters.default)
            )}
            sort={JSON.stringify(this.state.sortings.active)}
            fields={JSON.stringify(this.state.fields.active)}
            limit={150}
            hideSinglePageNav={true}
            keyField="id"
            path="/maintenance/list"
            blocker={{ spinnerFixed: true, hAuto: true }}
          >
            <MaintListItem
              highlightItem={this.props.itemId}
              specId={this.props.specId}
              onPick={this.props.onPick}
            />
          </List>
        )}
      </>
    );
  }
}
